import { render, staticRenderFns } from "./InvestmentCompleted.vue?vue&type=template&id=226ab8d0&scoped=true&"
import script from "./InvestmentCompleted.vue?vue&type=script&lang=ts&"
export * from "./InvestmentCompleted.vue?vue&type=script&lang=ts&"
import style0 from "./InvestmentCompleted.vue?vue&type=style&index=0&id=226ab8d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226ab8d0",
  null
  
)

export default component.exports